import { Auditable, QueryParams, SortParams } from "..";
export interface FormType extends Auditable {
    name: string;
    tenantId: number;

}

export const DefaultFormTypeQueryParams: QueryParams = {
    name: "",
}

export const DefaultFormTypeSortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false"
}

export enum FormTypes {
    Case = "Case",
    Tissue = "Tissue",
    QA = "QA"
}
